require("styles/mystyles.sass")

// const addAllbusinessAdScripts = () => {
//   const vars = document.createElement("script")
//   vars.id = "businessAd-variable-script"
//   vars.innerHTML = `var Ads_BA_ADIDsite = "bi-medien.de";var Ads_BA_ADIDsection = "rotation";var Ads_BA_keyword = ""`
//   document.body.appendChild(vars)

//   const scriptGPT = document.createElement("script")
//   scriptGPT.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
//   scriptGPT.id = "scriptGPT-script"
//   scriptGPT.async = true
//   document.body.appendChild(scriptGPT)

//   const scriptBiba = document.createElement("script")
//   scriptBiba.src = "https://storage.googleapis.com/ba_utils/biba.js"
//   scriptBiba.id = "scriptBiba-script"
//   scriptBiba.async = false
//   document.body.appendChild(scriptBiba)
// }

// const yeetAllBusinessAd = () => {
//   const business_ad_elements = [
//     document.getElementById("businessAd-variable-script"),
//     document.getElementById("scriptGPT-script"),
//     document.getElementById("scriptBiba-script"),
//   ]
//   business_ad_elements.map((element) => element?.remove())
// }

export const onRouteUpdate = ({ location, prevLocation }) => {
  document.getElementsByTagName("body")[0].style.backgroundColor = ""
  document.getElementById("___gatsby").style.backgroundColor = ""
  // location.pathname.split("/")[2] === "baumagazin"
  //   ? !document.getElementById("businessAd-variable-script")
  //     ? addAllbusinessAdScripts()
  //     : window?.Ads_BA_renew_tags()
  //   : console.log()

  // location.pathname.split("/")[2] !== "baumagazin" &&
  //   prevLocation?.pathname.split("/")?.[2] === "baumagazin" &&
  //   yeetAllBusinessAd()

  location.hash?.startsWith("#demosearch-box") &&
    window.scrollTo({ top: 200, behavior: "smooth" })
}
